// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LedgerGalleryRouteImport } from './routes/ledger-gallery'
import { Route as LedgerRouteImport } from './routes/ledger'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OauthMobileConsentRouteImport } from './routes/oauth.mobile-consent'
import { Route as OauthIdentityConsentRouteImport } from './routes/oauth.identity-consent'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as AuthWelcomeRouteImport } from './routes/auth.welcome'
import { Route as AuthSignUpRouteImport } from './routes/auth.sign-up'
import { Route as AuthResetPasswordRouteImport } from './routes/auth.reset-password'
import { Route as AuthLogoutRouteImport } from './routes/auth.logout'
import { Route as AuthLoginRouteImport } from './routes/auth.login'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth.forgot-password'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsSshKeysRouteImport } from './routes/settings.ssh-keys'
import { Route as SettingsGeneralRouteImport } from './routes/settings.general'
import { Route as SettingsDangerZoneRouteImport } from './routes/settings.danger-zone'
import { Route as SettingsBillingRouteImport } from './routes/settings.billing'
import { Route as SettingsApiKeysRouteImport } from './routes/settings.api-keys'
import { Route as SettingsSplatRouteImport } from './routes/settings.$'
import { Route as LedgerIndexRouteImport } from './routes/ledger.index'
import { Route as LedgerUsernameRouteImport } from './routes/ledger.$username'
import { Route as AuthLoginIndexRouteImport } from './routes/auth.login.index'
import { Route as AuthLoginDeviceRouteImport } from './routes/auth.login.device'
import { Route as Ledger0Income_statementRouteImport } from './routes/ledger.0.income_statement'
import { Route as LedgerLedgerOwnerLedgerNameRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName'
import { Route as Ledger_assetsLedgerRepoIdStaticSplatRouteImport } from './routes/ledger_assets.$ledgerRepoId.static.$'
import { Route as LedgerLedgerOwnerLedgerNameIndexRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.index'
import { Route as LedgerLedgerOwnerLedgerNameTrialBalanceRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.trial-balance'
import { Route as LedgerLedgerOwnerLedgerNameStatisticsRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.statistics'
import { Route as LedgerLedgerOwnerLedgerNameSettingsRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.settings'
import { Route as LedgerLedgerOwnerLedgerNameReceiptRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.receipt'
import { Route as LedgerLedgerOwnerLedgerNameQueryRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.query'
import { Route as LedgerLedgerOwnerLedgerNamePlaidConnectionsRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.plaid-connections'
import { Route as LedgerLedgerOwnerLedgerNameOverviewRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.overview'
import { Route as LedgerLedgerOwnerLedgerNameLinkRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.link'
import { Route as LedgerLedgerOwnerLedgerNameJournalRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.journal'
import { Route as LedgerLedgerOwnerLedgerNameIncomeStatementRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.income-statement'
import { Route as LedgerLedgerOwnerLedgerNameImportRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.import'
import { Route as LedgerLedgerOwnerLedgerNameHoldingsRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.holdings'
import { Route as LedgerLedgerOwnerLedgerNameEventsRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.events'
import { Route as LedgerLedgerOwnerLedgerNameErrorsRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.errors'
import { Route as LedgerLedgerOwnerLedgerNameDocumentsRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.documents'
import { Route as LedgerLedgerOwnerLedgerNameCommoditiesRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.commodities'
import { Route as LedgerLedgerOwnerLedgerNameCommitsRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.commits'
import { Route as LedgerLedgerOwnerLedgerNameCashFlowRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.cash-flow'
import { Route as LedgerLedgerOwnerLedgerNameBudgetRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.budget'
import { Route as LedgerLedgerOwnerLedgerNameBalanceSheetRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.balance-sheet'
import { Route as LedgerLedgerOwnerLedgerNameAskRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.ask'
import { Route as LedgerLedgerOwnerLedgerNameAgentRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.agent'
import { Route as LedgerLedgerOwnerLedgerNameAccountsRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.accounts'
import { Route as LedgerLedgerOwnerLedgerNameSplatRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.$'
import { Route as LedgerLedgerOwnerLedgerNamePullPrNumberRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.pull.$prNumber'
import { Route as LedgerLedgerOwnerLedgerNameFilesUploadRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.files.upload'
import { Route as LedgerLedgerOwnerLedgerNameFilesCreateRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.files.create'
import { Route as LedgerLedgerOwnerLedgerNameFilesContentRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.files.content'
import { Route as LedgerLedgerOwnerLedgerNameEntryEntryHashRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.entry.$entryHash'
import { Route as LedgerLedgerOwnerLedgerNameCommitCommitShaRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.commit.$commitSha'
import { Route as LedgerLedgerOwnerLedgerNameAccountAccountNameRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.account.$accountName'
import { Route as LedgerLedgerOwnerLedgerNameFilesTreeBranchSplatRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.files.tree.$branch.$'
import { Route as LedgerLedgerOwnerLedgerNameFilesNewBranchSplatRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.files.new.$branch.$'
import { Route as LedgerLedgerOwnerLedgerNameFilesBlobBranchSplatRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.files.blob.$branch.$'
import { Route as LedgerLedgerOwnerLedgerNameFilesUploadBranchSplatRouteImport } from './routes/ledger.$ledgerOwner.$ledgerName.files.upload.$branch.$'

const WelcomeRoute = WelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const LogoutRoute = LogoutRouteImport.update({
            id: '/logout',path: '/logout',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LedgerGalleryRoute = LedgerGalleryRouteImport.update({
            id: '/ledger-gallery',path: '/ledger-gallery',getParentRoute: () => rootRouteImport
          })
const LedgerRoute = LedgerRouteImport.update({
            id: '/ledger',path: '/ledger',getParentRoute: () => rootRouteImport
          })
const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const OauthMobileConsentRoute = OauthMobileConsentRouteImport.update({
            id: '/oauth/mobile-consent',path: '/oauth/mobile-consent',getParentRoute: () => rootRouteImport
          })
const OauthIdentityConsentRoute = OauthIdentityConsentRouteImport.update({
            id: '/oauth/identity-consent',path: '/oauth/identity-consent',getParentRoute: () => rootRouteImport
          })
const OauthConsentRoute = OauthConsentRouteImport.update({
            id: '/oauth/consent',path: '/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AuthWelcomeRoute = AuthWelcomeRouteImport.update({
            id: '/auth/welcome',path: '/auth/welcome',getParentRoute: () => rootRouteImport
          })
const AuthSignUpRoute = AuthSignUpRouteImport.update({
            id: '/auth/sign-up',path: '/auth/sign-up',getParentRoute: () => rootRouteImport
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/auth/reset-password',path: '/auth/reset-password',getParentRoute: () => rootRouteImport
          })
const AuthLogoutRoute = AuthLogoutRouteImport.update({
            id: '/auth/logout',path: '/auth/logout',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/auth/login',path: '/auth/login',getParentRoute: () => rootRouteImport
          })
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
            id: '/auth/forgot-password',path: '/auth/forgot-password',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const SettingsIndexRoute = SettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SettingsRoute
          })
const SettingsSshKeysRoute = SettingsSshKeysRouteImport.update({
            id: '/ssh-keys',path: '/ssh-keys',getParentRoute: () => SettingsRoute
          })
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
            id: '/general',path: '/general',getParentRoute: () => SettingsRoute
          })
const SettingsDangerZoneRoute = SettingsDangerZoneRouteImport.update({
            id: '/danger-zone',path: '/danger-zone',getParentRoute: () => SettingsRoute
          })
const SettingsBillingRoute = SettingsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => SettingsRoute
          })
const SettingsApiKeysRoute = SettingsApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => SettingsRoute
          })
const SettingsSplatRoute = SettingsSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => SettingsRoute
          })
const LedgerIndexRoute = LedgerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LedgerRoute
          })
const LedgerUsernameRoute = LedgerUsernameRouteImport.update({
            id: '/$username',path: '/$username',getParentRoute: () => LedgerRoute
          })
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthLoginRoute
          })
const AuthLoginDeviceRoute = AuthLoginDeviceRouteImport.update({
            id: '/device',path: '/device',getParentRoute: () => AuthLoginRoute
          })
const Ledger0Income_statementRoute = Ledger0Income_statementRouteImport.update({
            id: '/0/income_statement',path: '/0/income_statement',getParentRoute: () => LedgerRoute
          })
const LedgerLedgerOwnerLedgerNameRoute = LedgerLedgerOwnerLedgerNameRouteImport.update({
            id: '/$ledgerOwner/$ledgerName',path: '/$ledgerOwner/$ledgerName',getParentRoute: () => LedgerRoute
          })
const Ledger_assetsLedgerRepoIdStaticSplatRoute = Ledger_assetsLedgerRepoIdStaticSplatRouteImport.update({
            id: '/ledger_assets/$ledgerRepoId/static/$',path: '/ledger_assets/$ledgerRepoId/static/$',getParentRoute: () => rootRouteImport
          })
const LedgerLedgerOwnerLedgerNameIndexRoute = LedgerLedgerOwnerLedgerNameIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameTrialBalanceRoute = LedgerLedgerOwnerLedgerNameTrialBalanceRouteImport.update({
            id: '/trial-balance',path: '/trial-balance',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameStatisticsRoute = LedgerLedgerOwnerLedgerNameStatisticsRouteImport.update({
            id: '/statistics',path: '/statistics',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameSettingsRoute = LedgerLedgerOwnerLedgerNameSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameReceiptRoute = LedgerLedgerOwnerLedgerNameReceiptRouteImport.update({
            id: '/receipt',path: '/receipt',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameQueryRoute = LedgerLedgerOwnerLedgerNameQueryRouteImport.update({
            id: '/query',path: '/query',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNamePlaidConnectionsRoute = LedgerLedgerOwnerLedgerNamePlaidConnectionsRouteImport.update({
            id: '/plaid-connections',path: '/plaid-connections',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameOverviewRoute = LedgerLedgerOwnerLedgerNameOverviewRouteImport.update({
            id: '/overview',path: '/overview',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameLinkRoute = LedgerLedgerOwnerLedgerNameLinkRouteImport.update({
            id: '/link',path: '/link',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameJournalRoute = LedgerLedgerOwnerLedgerNameJournalRouteImport.update({
            id: '/journal',path: '/journal',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameIncomeStatementRoute = LedgerLedgerOwnerLedgerNameIncomeStatementRouteImport.update({
            id: '/income-statement',path: '/income-statement',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameImportRoute = LedgerLedgerOwnerLedgerNameImportRouteImport.update({
            id: '/import',path: '/import',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameHoldingsRoute = LedgerLedgerOwnerLedgerNameHoldingsRouteImport.update({
            id: '/holdings',path: '/holdings',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameEventsRoute = LedgerLedgerOwnerLedgerNameEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameErrorsRoute = LedgerLedgerOwnerLedgerNameErrorsRouteImport.update({
            id: '/errors',path: '/errors',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameDocumentsRoute = LedgerLedgerOwnerLedgerNameDocumentsRouteImport.update({
            id: '/documents',path: '/documents',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameCommoditiesRoute = LedgerLedgerOwnerLedgerNameCommoditiesRouteImport.update({
            id: '/commodities',path: '/commodities',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameCommitsRoute = LedgerLedgerOwnerLedgerNameCommitsRouteImport.update({
            id: '/commits',path: '/commits',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameCashFlowRoute = LedgerLedgerOwnerLedgerNameCashFlowRouteImport.update({
            id: '/cash-flow',path: '/cash-flow',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameBudgetRoute = LedgerLedgerOwnerLedgerNameBudgetRouteImport.update({
            id: '/budget',path: '/budget',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameBalanceSheetRoute = LedgerLedgerOwnerLedgerNameBalanceSheetRouteImport.update({
            id: '/balance-sheet',path: '/balance-sheet',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameAskRoute = LedgerLedgerOwnerLedgerNameAskRouteImport.update({
            id: '/ask',path: '/ask',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameAgentRoute = LedgerLedgerOwnerLedgerNameAgentRouteImport.update({
            id: '/agent',path: '/agent',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameAccountsRoute = LedgerLedgerOwnerLedgerNameAccountsRouteImport.update({
            id: '/accounts',path: '/accounts',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameSplatRoute = LedgerLedgerOwnerLedgerNameSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNamePullPrNumberRoute = LedgerLedgerOwnerLedgerNamePullPrNumberRouteImport.update({
            id: '/pull/$prNumber',path: '/pull/$prNumber',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameFilesUploadRoute = LedgerLedgerOwnerLedgerNameFilesUploadRouteImport.update({
            id: '/files/upload',path: '/files/upload',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameFilesCreateRoute = LedgerLedgerOwnerLedgerNameFilesCreateRouteImport.update({
            id: '/files/create',path: '/files/create',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameFilesContentRoute = LedgerLedgerOwnerLedgerNameFilesContentRouteImport.update({
            id: '/files/content',path: '/files/content',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameEntryEntryHashRoute = LedgerLedgerOwnerLedgerNameEntryEntryHashRouteImport.update({
            id: '/entry/$entryHash',path: '/entry/$entryHash',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameCommitCommitShaRoute = LedgerLedgerOwnerLedgerNameCommitCommitShaRouteImport.update({
            id: '/commit/$commitSha',path: '/commit/$commitSha',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameAccountAccountNameRoute = LedgerLedgerOwnerLedgerNameAccountAccountNameRouteImport.update({
            id: '/account/$accountName',path: '/account/$accountName',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameFilesTreeBranchSplatRoute = LedgerLedgerOwnerLedgerNameFilesTreeBranchSplatRouteImport.update({
            id: '/files/tree/$branch/$',path: '/files/tree/$branch/$',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameFilesNewBranchSplatRoute = LedgerLedgerOwnerLedgerNameFilesNewBranchSplatRouteImport.update({
            id: '/files/new/$branch/$',path: '/files/new/$branch/$',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameFilesBlobBranchSplatRoute = LedgerLedgerOwnerLedgerNameFilesBlobBranchSplatRouteImport.update({
            id: '/files/blob/$branch/$',path: '/files/blob/$branch/$',getParentRoute: () => LedgerLedgerOwnerLedgerNameRoute
          })
const LedgerLedgerOwnerLedgerNameFilesUploadBranchSplatRoute = LedgerLedgerOwnerLedgerNameFilesUploadBranchSplatRouteImport.update({
            id: '/$branch/$',path: '/$branch/$',getParentRoute: () => LedgerLedgerOwnerLedgerNameFilesUploadRoute
          })





const LedgerLedgerOwnerLedgerNameFilesUploadRouteChildren = {
  LedgerLedgerOwnerLedgerNameFilesUploadBranchSplatRoute: LedgerLedgerOwnerLedgerNameFilesUploadBranchSplatRoute
}

const LedgerLedgerOwnerLedgerNameFilesUploadRouteWithChildren = LedgerLedgerOwnerLedgerNameFilesUploadRoute._addFileChildren(LedgerLedgerOwnerLedgerNameFilesUploadRouteChildren)



const LedgerLedgerOwnerLedgerNameRouteChildren = {
  LedgerLedgerOwnerLedgerNameSplatRoute: LedgerLedgerOwnerLedgerNameSplatRoute,LedgerLedgerOwnerLedgerNameAccountsRoute: LedgerLedgerOwnerLedgerNameAccountsRoute,LedgerLedgerOwnerLedgerNameAgentRoute: LedgerLedgerOwnerLedgerNameAgentRoute,LedgerLedgerOwnerLedgerNameAskRoute: LedgerLedgerOwnerLedgerNameAskRoute,LedgerLedgerOwnerLedgerNameBalanceSheetRoute: LedgerLedgerOwnerLedgerNameBalanceSheetRoute,LedgerLedgerOwnerLedgerNameBudgetRoute: LedgerLedgerOwnerLedgerNameBudgetRoute,LedgerLedgerOwnerLedgerNameCashFlowRoute: LedgerLedgerOwnerLedgerNameCashFlowRoute,LedgerLedgerOwnerLedgerNameCommitsRoute: LedgerLedgerOwnerLedgerNameCommitsRoute,LedgerLedgerOwnerLedgerNameCommoditiesRoute: LedgerLedgerOwnerLedgerNameCommoditiesRoute,LedgerLedgerOwnerLedgerNameDocumentsRoute: LedgerLedgerOwnerLedgerNameDocumentsRoute,LedgerLedgerOwnerLedgerNameErrorsRoute: LedgerLedgerOwnerLedgerNameErrorsRoute,LedgerLedgerOwnerLedgerNameEventsRoute: LedgerLedgerOwnerLedgerNameEventsRoute,LedgerLedgerOwnerLedgerNameHoldingsRoute: LedgerLedgerOwnerLedgerNameHoldingsRoute,LedgerLedgerOwnerLedgerNameImportRoute: LedgerLedgerOwnerLedgerNameImportRoute,LedgerLedgerOwnerLedgerNameIncomeStatementRoute: LedgerLedgerOwnerLedgerNameIncomeStatementRoute,LedgerLedgerOwnerLedgerNameJournalRoute: LedgerLedgerOwnerLedgerNameJournalRoute,LedgerLedgerOwnerLedgerNameLinkRoute: LedgerLedgerOwnerLedgerNameLinkRoute,LedgerLedgerOwnerLedgerNameOverviewRoute: LedgerLedgerOwnerLedgerNameOverviewRoute,LedgerLedgerOwnerLedgerNamePlaidConnectionsRoute: LedgerLedgerOwnerLedgerNamePlaidConnectionsRoute,LedgerLedgerOwnerLedgerNameQueryRoute: LedgerLedgerOwnerLedgerNameQueryRoute,LedgerLedgerOwnerLedgerNameReceiptRoute: LedgerLedgerOwnerLedgerNameReceiptRoute,LedgerLedgerOwnerLedgerNameSettingsRoute: LedgerLedgerOwnerLedgerNameSettingsRoute,LedgerLedgerOwnerLedgerNameStatisticsRoute: LedgerLedgerOwnerLedgerNameStatisticsRoute,LedgerLedgerOwnerLedgerNameTrialBalanceRoute: LedgerLedgerOwnerLedgerNameTrialBalanceRoute,LedgerLedgerOwnerLedgerNameIndexRoute: LedgerLedgerOwnerLedgerNameIndexRoute,LedgerLedgerOwnerLedgerNameAccountAccountNameRoute: LedgerLedgerOwnerLedgerNameAccountAccountNameRoute,LedgerLedgerOwnerLedgerNameCommitCommitShaRoute: LedgerLedgerOwnerLedgerNameCommitCommitShaRoute,LedgerLedgerOwnerLedgerNameEntryEntryHashRoute: LedgerLedgerOwnerLedgerNameEntryEntryHashRoute,LedgerLedgerOwnerLedgerNameFilesContentRoute: LedgerLedgerOwnerLedgerNameFilesContentRoute,LedgerLedgerOwnerLedgerNameFilesCreateRoute: LedgerLedgerOwnerLedgerNameFilesCreateRoute,LedgerLedgerOwnerLedgerNameFilesUploadRoute: LedgerLedgerOwnerLedgerNameFilesUploadRouteWithChildren,LedgerLedgerOwnerLedgerNamePullPrNumberRoute: LedgerLedgerOwnerLedgerNamePullPrNumberRoute,LedgerLedgerOwnerLedgerNameFilesBlobBranchSplatRoute: LedgerLedgerOwnerLedgerNameFilesBlobBranchSplatRoute,LedgerLedgerOwnerLedgerNameFilesNewBranchSplatRoute: LedgerLedgerOwnerLedgerNameFilesNewBranchSplatRoute,LedgerLedgerOwnerLedgerNameFilesTreeBranchSplatRoute: LedgerLedgerOwnerLedgerNameFilesTreeBranchSplatRoute
}

const LedgerLedgerOwnerLedgerNameRouteWithChildren = LedgerLedgerOwnerLedgerNameRoute._addFileChildren(LedgerLedgerOwnerLedgerNameRouteChildren)



const LedgerRouteChildren = {
  LedgerUsernameRoute: LedgerUsernameRoute,LedgerIndexRoute: LedgerIndexRoute,LedgerLedgerOwnerLedgerNameRoute: LedgerLedgerOwnerLedgerNameRouteWithChildren,Ledger0Income_statementRoute: Ledger0Income_statementRoute
}

const LedgerRouteWithChildren = LedgerRoute._addFileChildren(LedgerRouteChildren)




const SettingsRouteChildren = {
  SettingsSplatRoute: SettingsSplatRoute,SettingsApiKeysRoute: SettingsApiKeysRoute,SettingsBillingRoute: SettingsBillingRoute,SettingsDangerZoneRoute: SettingsDangerZoneRoute,SettingsGeneralRoute: SettingsGeneralRoute,SettingsSshKeysRoute: SettingsSshKeysRoute,SettingsIndexRoute: SettingsIndexRoute
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(SettingsRouteChildren)




const AuthLoginRouteChildren = {
  AuthLoginDeviceRoute: AuthLoginDeviceRoute,AuthLoginIndexRoute: AuthLoginIndexRoute
}

const AuthLoginRouteWithChildren = AuthLoginRoute._addFileChildren(AuthLoginRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,DashboardRoute: DashboardRoute,ForgotPasswordRoute: ForgotPasswordRoute,GalleryRoute: GalleryRoute,LedgerRoute: LedgerRouteWithChildren,LedgerGalleryRoute: LedgerGalleryRoute,LoginRoute: LoginRoute,LogoutRoute: LogoutRoute,ResetPasswordRoute: ResetPasswordRoute,SettingsRoute: SettingsRouteWithChildren,SignUpRoute: SignUpRoute,WelcomeRoute: WelcomeRoute,AuthCallbackRoute: AuthCallbackRoute,AuthForgotPasswordRoute: AuthForgotPasswordRoute,AuthLoginRoute: AuthLoginRouteWithChildren,AuthLogoutRoute: AuthLogoutRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthSignUpRoute: AuthSignUpRoute,AuthWelcomeRoute: AuthWelcomeRoute,OauthConsentRoute: OauthConsentRoute,OauthIdentityConsentRoute: OauthIdentityConsentRoute,OauthMobileConsentRoute: OauthMobileConsentRoute,Ledger_assetsLedgerRepoIdStaticSplatRoute: Ledger_assetsLedgerRepoIdStaticSplatRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)